import React from 'react'
import { Formik } from 'formik'
import { toast } from 'react-toastify'
import Container from './styles'
import sendForm from '../../services/sendforms'

const initialValues = { field_email: '', field_name: '' }
const NewsletterCTA = () => (
  <Container>
    <h3>Receba conteúdos exclusivos</h3>
    <Formik
      initialValues={initialValues}
      validate={values => {
        const errors = {}
        if (!values.field_email) {
          errors.field_email = 'Campo obrigatório'
          errors.field_emailClass = 'error'
        } else if (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.field_email)
        ) {
          errors.field_email = 'E-mail inválido'
          errors.field_emailClass = 'error'
        }
        return errors
      }}
      onSubmit={async (values, { resetForm }) => {
        toast.info('Enviando', {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: false,
          draggable: true,
          progress: undefined,
        })
        const wordpressFormId = '10973'
        const response = await sendForm(wordpressFormId, values)
        if (response.status === 'mail_sent') {
          toast.success(response.message, {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'formSend',
            category: 'Formulário',
            action: 'Send',
            label: `Cadastro newsletter`,
          })
          resetForm(initialValues)
        } else {
          toast.error(
            'Desculpe, algum erro ocorreu. Tente novamente mais tarde',
            {
              position: 'top-center',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            }
          )
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        /* and other goodies */
      }) => (
        <form onSubmit={handleSubmit}>
          <fieldset>
            <input
              type="text"
              name="field_name"
              id="nome"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.field_name}
              placeholder="Seu Nome"
              className={errors.field_nameClass}
            />
            <span>
              {errors.field_name && touched.field_name && errors.field_name}
            </span>
          </fieldset>
          <fieldset>
            <input
              type="email"
              name="field_email"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.field_email}
              id="email"
              placeholder="Seu E-mail"
              className={errors.field_emailClass}
            />
            <span>
              {errors.field_email && touched.field_email && errors.field_email}
            </span>
          </fieldset>

          <button type="submit" className="button" disabled={isSubmitting}>
            Cadastrar e-mail
          </button>
        </form>
      )}
    </Formik>
  </Container>
)

export default NewsletterCTA
